import styled from "styled-components";
import {
  COLORS,
  responsive,
  tabletMidRange,
} from "../../styles/constants.style";

export const TimelineCollapsableActivityWrapper = styled.div`
  border-bottom: 1px solid ${COLORS.primary_light_blue3};
  .MuiPaper-elevation {
    border-radius: 0px;
    box-shadow: none;
  }

  .MuiAccordionDetails-root {
    padding: 12px 0;
    border-top: 1px dotted ${COLORS.primary_light_blue3};

    ${responsive.MOBILE`
      padding: 0px 0;
    `}

    .accordion-details {
      padding-top: 16px !important;
    }

    .MuiGrid2-root {
      padding-right: 16px;
      margin-top: 24px;
      &:nth-child(-n + 3) {
        margin-top: 0px;
      }

      ${responsive.TABLET_PORTRAIT`
          &:nth-child(1), &:nth-child(2) {
            margin-top: 0px;
          }
          &:nth-child(n+3) {
            margin-top: 24px;
        }
      `}

      ${tabletMidRange`
        &:nth-child(3) {
        margin-top: 24px;
        }
      `}

      ${responsive.MOBILE`
          &:nth-child(1) {
            margin-top: 0px;
          }
          &:nth-child(n+2) {
            margin-top: 16px;
          }
      `}
    }
  }

  .MuiAccordionSummary-root,
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 58px;
  }

  .MuiAccordionSummary-root {
    padding-right: 0;
    background-color: ${COLORS.cirrus_white};

    ${responsive.MOBILE`
      padding-left: 0;
    `}

    .MuiAccordionSummary-content {
      margin: 0;
    }
    box-shadow: none;
    &.Mui-expanded {
      margin: 0;
    }
    .MuiAccordionSummary-expandIconWrapper {
      margin-top: 0px;
      margin-right: 34px;
    }
  }
`;

export const TimelineActivityDivider = styled.div`
  width: 4px;
  height: 32px;
  border-radius: 4px;
  background-color: ${COLORS.primary_light_blue2};
  margin-left: 16px;
  margin-right: 16px;
`;

export const TimelineActivityHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 20px;
  cursor: auto;
  .MuiChip-root {
    min-width: 205px;
  }

  .MuiLink-root {
    text-align: left;
    flex-grow: 1;
    text-underline-offset: 5px;
  }
  .MuiTypography-root.label {
    text-align: left;
    flex-grow: 1;
  }

  .MuiTypography-root.body3 {
    text-align: right;
  }
  .more-option {
    margin-left: 8px;
    margin-right: 8px;
    width: 32px;
    .MuiIconButton-root {
      padding: 4px;
    }
  }
  .activity-title-link {
    max-width: 400px;
  }
`;
